import type { AccountId, ProjectKey } from '@atlassian/jira-shared-types/src/general.tsx';
import { setUserProperties } from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';

const getProppertyKeyFromProjectId = (projectKey: ProjectKey) =>
	`jsm-all-queues-state_is-open-${projectKey}`;

const MISSING_ACCOUNT_ID_ERROR_MSG = 'accountId is missing.';

export const updateQueueSidebarExpandAllQueuesDataUserProperty = (
	isExpanded: boolean,
	projectKey: ProjectKey,
	accountId?: AccountId | null,
): Promise<void> => {
	if (!accountId) {
		throw new Error(MISSING_ACCOUNT_ID_ERROR_MSG);
	}
	return setUserProperties(
		accountId,
		getProppertyKeyFromProjectId(projectKey),
		JSON.stringify(isExpanded),
	);
};
